const menu = [
  {
    title: '语音识别',
    icon: '#icon-yysb',
    submenu: [
      {
        key: "iat",
        title: "语音听写（流式版）",
        path: '/services/iat'
      },
      {
        key: "lfasr",
        title: "语音转写",
        path: '/services/lfasr'
      },
      {
        key: "rta",
        title: "实时语音转写",
        path: '/services/rta'
      },
      {
        key: "esriat",
        title: "离线语音听写",
        path: '/services/esriat'
      },
      {
        key: "awaken",
        title: "语音唤醒",
        path: '/services/awaken'
      },
      {
        key: "mlcsb",
        title: "离线命令词识别",
        path: '/services/mlcsb'
      },
    ]
  }, {
    title: '语音合成',
    icon: '#icon-yyhc',
    submenu: [
      {
        key: "tts",
        title: "在线语音合成（流式版）",
        path: '/services/tts'
      },
      // {
      //   key: "online_tts",
      //   title: "在线语音合成（普通版）",
      //   path: '/services/online_tts'
      // },
      {
        key: "aisound",
        title: "离线语音合成（普通版）",
        path: '/services/aisound'
      },
      {
        key: "xtts",
        title: "离线语音合成（高品质版）",
        path: '/services/xtts'
      },
    ]
  }, {
    title: '语音扩展',
    icon: '#icon-yykz',
    submenu: [
      // {
      //   key: "isv",
      //   title: "声纹识别",
      //   path: '/services/isv'
      // },
      {
        key: "ise",
        title: "语音评测（流式版）",
        path: '/services/ise'
      },
      {
        key: "wse",
        title: "语音评测（普通版）",
        path: '/services/wse'
      },
      {
        key: "igr_gray",
        title: "性别年龄识别",
        path: '/services/igr_gray'
      },
      {
        key: "qbh",
        title: "歌曲识别",
        path: '/services/qbh'
      },
    ]
  }, {
    title: '司法A.I.产品',
    icon: '#icon-judicial',
    submenu: [
      // {
      //   key: "chatroom",
      //   title: "司法聊天室",
      //   path: '/services/chatroom'
      // },
      // {
      //   key: "ist",
      //   title: "司法实时语音转写",
      //   path: '/services/ist'
      // },
      {
        key: "judicial-ocr",
        title: "卷宗识别",
        path: '/services/judicial-ocr'
      }
    ]
  }, {
    title: '人脸识别',
    icon: '#icon-rlsb',
    submenu: [
      {
        key: "face_compare",
        title: "人脸比对",
        path: "/services/face_compare"
      },
      {
        key: "wfv",
        title: "人脸比对sensetime",
        path: '/services/wfv'
      },
      {
        key: "wwv",
        title: "人脸水印照比对",
        path: '/services/wwv'
      },
      {
        key: "anti_spoof",
        title: "静默活体检测",
        path: '/services/anti_spoof'
      },
      {
        key: "wsd",
        title: "静默活体检测sensetime",
        path: '/services/wsd'
      },
      // {
      //   key: "face",
      //   title: "人脸验证与检索",
      //   path: '/services/face'
      // },
      {
        key: "face_status",
        title: "配合式活体检测",
        path: '/services/face_status'
      },
      {
        key: "face_detect",
        title: "人脸检测和属性分析",
        path: '/services/face_detect'
      },
      {
        key: "sex-age-expression-face_score",
        title: "人脸特征分析 tuputech",
        path: '/services/sex-age-expression-face_score'
      },
    ]
  }, {
    title: '文字识别',
    icon: '#icon-wzsb',
    submenu: [
      {
        key: "hw",
        title: "手写文字识别",
        path: '/services/hw'
      },
      {
        key: "general",
        title: "印刷文字识别",
        path: '/services/general'
      },
      {
        key: "minority_language",
        title: "印刷文字识别（多语种）",
        path: '/services/minority_language'
      },
      {
        key: "recognize_document",
        title: "印刷文字识别（多语种） intsig",
        path: '/services/recognize_document'
      },
      {
        key: "business_card",
        title: "名片识别",
        path: '/services/business_card'
      },
      {
        key: "idcard",
        title: "身份证识别 intsig",
        path: '/services/idcard'
      },
      {
        key: "bankcard",
        title: "银行卡识别",
        path: '/services/bankcard'
      },
      {
        key: "business_license",
        title: "营业执照识别 intsig",
        path: '/services/business_license'
      },
      {
        key: "invoice",
        title: "增值税发票识别 intsig",
        path: '/services/invoice'
      },
      {
        key: "itr",
        title: "拍照速算识别",
        path: '/services/itr'
      },
      {
        key: "itr_formula",
        title: "公式识别",
        path: '/services/itr_formula'
      },
      {
        key: "fingerocr",
        title: "指尖文字识别",
        path: '/services/fingerocr'
      },
      {
        key: "jd_ocr_car",
        title: "车牌识别 JD",
        path: '/services/jd_ocr_car'
      },
      {
        key: "jd_ocr_driver",
        title: "驾驶证识别 JD",
        path: '/services/jd_ocr_driver'
      },
      {
        key: "jd_ocr_vehicle",
        title: "行驶证识别 JD",
        path: '/services/jd_ocr_vehicle'
      },
      {
        key: "idcard_self",
        title: "身份证识别",
        path: '/services/idcard_self'
      },
      {
        key: "invoice_self",
        title: "增值税发票识别",
        path: '/services/invoice_self'
      },
      {
        key: "business_license_self",
        title: "营业执照识别",
        path: '/services/business_license_self'
      },
      {
        key: "train_ticket_self",
        title: "火车票识别",
        path: '/services/train_ticket_self'
      },
      {
        key: "taxi_ticket_self",
        title: "出租车发票识别",
        path: '/services/taxi_ticket_self'
      },
    ]
  }, {
    title: '图像识别',
    icon: '#icon-txsb',
    submenu: [
      {
        key: "scene",
        title: "场景识别",
        path: '/services/scene'
      },
      {
        key: "currency",
        title: "物体识别",
        path: '/services/currency'
      },
      {
        key: "site_identification",
        title: "场所识别",
        path: '/services/site_identification'
      },
    ]
  }, {
    title: '内容审核',
    icon: '#icon-nrsh',
    submenu: [
      {
        key: "wsf",
        title: "色情内容过滤",
        path: '/services/wsf'
      },
      {
        key: "wcf",
        title: "政治人物检查",
        path: '/services/wcf'
      },
      {
        key: "wtf",
        title: "暴恐敏感信息过滤",
        path: '/services/wtf'
      },
      {
        key: "waf",
        title: "广告过滤",
        path: '/services/waf'
      },
    ]
  }, {
    title: '自然语言处理',
    icon: '#icon-zyrycl',
    submenu: [
      {
        key: "its",
        title: "机器翻译",
        path: '/services/its'
      },
      {
        key: "ots",
        title: "机器翻译(niutrans)",
        path: '/services/ots'
      },{
        key: "text_check",
        title: "文本纠错",
        path: '/services/text_check'
      },
      {
        key: "cws-pos-ner",
        title: "词法分析",
        path: '/services/cws-pos-ner'
      },
      {
        key: "dp",
        title: "依存句法分析",
        path: '/services/dp'
      },
      {
        key: "srl",
        title: "语义角色标注",
        path: '/services/srl'
      },
      {
        key: "sdp",
        title: "语义依存分析（依存树）",
        path: '/services/sdp'
      },
      {
        key: "sdgp",
        title: "语义依存分析（依存图）",
        path: '/services/sdgp'
      },
      {
        key: "sa",
        title: "情感分析",
        path: '/services/sa'
      },
      {
        key: "ke",
        title: "关键词提取",
        path: '/services/ke'
      },
    ]
  }, {
    title: '基础服务',
    icon: '#icon-jcfw',
    submenu: [
      // {
      //   key: "xpush",
      //   title: "讯推",
      //   path: '/services/xpush'
      // },
      // {
      //   key: "aiui_soft",
      //   title: "AIUI平台",
      //   path: '/services/aiui_soft'
      // },
      {
        key: "xfyeta",
        title: "A.I.客服平台能力中间件",
        path: '/services/xfyeta'
      },
      {
        key: "znyj",
        title: "智能硬件通用解决方案",
        path: '/services/znyj'
      },
    ]
  }
]

export default menu


// WEBPACK FOOTER //
// ./app/constant/menu.js